import { Link } from 'react-router-dom';

import { CrewMemberCellProps } from './CrewMemberCell.types';

export function CrewMemberCell({ crewMember, showCompany = true }: CrewMemberCellProps) {
  if (showCompany && !crewMember.registration?.company) {
    console.warn('Company is not included on crew member object');
  }

  return (
    <>
      {crewMember.user.fullName}
      {showCompany && crewMember.registration?.company && (
        <span className="block text-sm">{crewMember.registration.company.name}</span>
      )}
    </>
  );
}
